import { RouteRecordRaw } from 'vue-router'

import {
  RESIDENCY_ROUTE_NAMES,
  RESIDENCY_ROUTE_NAMES_NEW,
} from '@/modules/residency/constants/ResidencyRouteNames'

import { UserGroup } from '@generated/types'

export const residencyRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/residency',
    meta: { requiresAuth: UserGroup.MANAGERS },
    children: [
      {
        path: '',
        name: RESIDENCY_ROUTE_NAMES.LIST,
        component: () => import('@/modules/residency/pages/ResidencyList.vue'),
        meta: { pageTitle: 'Residency' },
      },
      {
        path: ':residencyId',
        name: RESIDENCY_ROUTE_NAMES.DETAIL,
        component: () => import('@/modules/residency/pages/ResidencyDetail.vue'),
        props: route => {
          const residencyId = route.params.residencyId
          return { residencyId: isNaN(Number(residencyId)) ? residencyId : Number(residencyId) }
        },
        meta: {
          pageTitle: 'Residency Detail',
          usesCustomNavbar: true,
        },
      },
    ],
  },
  {
    path: '/venue/residency-new',
    meta: { requiresAuth: UserGroup.MANAGERS },
    children: [
      {
        path: '',
        name: RESIDENCY_ROUTE_NAMES_NEW.LIST,
        component: () => import('@/modules/residency/pages/ResidencyListNew.vue'),
        meta: { pageTitle: 'Residency List' },
      },
      {
        path: ':residencyId',
        name: RESIDENCY_ROUTE_NAMES_NEW.DETAIL,
        component: () => import('@/modules/residency/pages/ResidencyDetailNew.vue'),
        props: route => {
          const residencyId = route.params.residencyId
          return { residencyId: isNaN(Number(residencyId)) ? residencyId : Number(residencyId) }
        },
        meta: {
          pageTitle: 'Residency Detail',
          usesCustomNavbar: true,
        },
      },
    ],
  },
]
